import { render, staticRenderFns } from "./moreOrigin.vue?vue&type=template&id=14eaecfa&"
import script from "./moreOrigin.vue?vue&type=script&lang=js&"
export * from "./moreOrigin.vue?vue&type=script&lang=js&"
import style0 from "./moreOrigin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports